import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Order matters: xp.css styles bare elements, our globals correct it, and
// CSS modules (imported by components) land last so they win ties.
import 'xp.css/dist/XP.css';
import './theme/global.css';

import { Root } from './Root';

const container = document.getElementById('root');
if (!container) throw new Error('#root is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <Root />
  </StrictMode>,
);
